module.exports = __webpack_public_path__ + "img/FundacionLasRosasLogo.d3671fd0.svg";